import React from "react";
import { Box, Table, Thead, Tbody, Tr, Th, Td, Text, Badge, useColorModeValue } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import Card from "components/card/Card.js";
import { GOLD_TEXT } from "constants/brandColors";

// `rows` is /reports/news/top's data: News rows (already filtered to
// status=PUBLISHED, ordered by views desc) with `translations`/`category`
// pre-scoped server-side to a single requested locale, so translations[0]
// is either that locale's row or undefined (no fallback locale server-side).
export default function TopNewsTable({ rows }) {
  const { t } = useTranslation();
  const tableHeaderBg = useColorModeValue("gray.50", "gray.700");
  const tableHeaderColor = useColorModeValue("gray.600", "gray.200");

  return (
    <Card w="100%" p="20px">
      <Text color={GOLD_TEXT} fontSize="xl" fontWeight="700" mb="14px">
        {t("Top News")}
      </Text>
      {rows?.length ? (
        <Box overflowX="auto">
          <Table variant="simple" size="sm">
            <Thead>
              <Tr bg={tableHeaderBg}>
                <Th color={tableHeaderColor}>#</Th>
                <Th color={tableHeaderColor}>{t("Title")}</Th>
                <Th color={tableHeaderColor}>{t("Category")}</Th>
                <Th color={tableHeaderColor} isNumeric>{t("Views")}</Th>
                <Th color={tableHeaderColor}>{t("Published At")}</Th>
              </Tr>
            </Thead>
            <Tbody>
              {rows.map((row, index) => (
                <Tr key={row.id}>
                  <Td>{index + 1}</Td>
                  <Td>
                    <Text fontWeight="600">{row.translations?.[0]?.title || t("Untitled")}</Text>
                    {row.breaking_news && (
                      <Badge ms={2} colorScheme="red" fontSize="0.6em">{t("Breaking")}</Badge>
                    )}
                  </Td>
                  <Td>{row.category?.translations?.[0]?.name || row.category?.slug || "-"}</Td>
                  <Td isNumeric>{row.views ?? 0}</Td>
                  <Td>{row.publishedAt ? new Date(row.publishedAt).toLocaleDateString() : "-"}</Td>
                </Tr>
              ))}
            </Tbody>
          </Table>
        </Box>
      ) : (
        <Text color="gray.500" textAlign="center" py={10}>{t("No data found")}</Text>
      )}
    </Card>
  );
}
